import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { SecurityService } from 'app/core/security/security.service';

/**
 * This is the landing page when you first access the website.
 */
@Component({
    selector: 'pcg-home',
    templateUrl: './home.component.html',
    standalone: false,
})
export class HomeComponent implements OnInit {
    constructor(
        private sec: SecurityService,
        private router: Router,
        public title: Title
    ) {
        title.setTitle('ERFS');
    }

    ngOnInit() {
        if (this.sec.isLoggedOn()) {
            this.router.navigate(['/dashboard']);
        } else {
            this.router.navigate(['/login']);
        }
    }
}
